import React, { useState, useEffect } from 'react';

import type { ChangeContext } from 'tea-component';

export default function useSearch(props?: {
  searchable?: boolean;
  searchValue?: string;
  onSearchValueChange?: (payload: string, context: ChangeContext<React.SyntheticEvent<Element, Event>>) => void;
  onSearch?: (payload: string, context?: ChangeContext<React.SyntheticEvent<Element, Event>>) => void;
}) {
  const { searchable = false, searchValue: searchValueProps, onSearchValueChange, onSearch } = props || {};

  const [searchMode, setSearchMode] = useState(false);
  const [searchValue, setSearchValue] = useState<string>(searchValueProps || '');

  const handleSearchValueChange = (payload: string, context: ChangeContext<React.SyntheticEvent<Element, Event>>) => {
    if (!searchable) return;
    const payloadTmp = payload || '';
    setSearchValue(payloadTmp);
    onSearchValueChange?.(payloadTmp, context);
  };

  const handleSearch = (payload?: string, context?: ChangeContext<React.SyntheticEvent<Element, Event>>) => {
    if (!searchable) return;
    const payloadTmp = payload || '';
    setSearchMode(!!payloadTmp);
    setSearchValue(payloadTmp);
    onSearch?.(payloadTmp, context);
  };

  useEffect(() => {
    if (!searchable) return;
    if (searchValueProps === searchValue) return;
    setSearchValue(searchValueProps || '');
  }, [searchable, searchValueProps]);

  return {
    // 是否处于搜索模式
    searchMode: searchable && searchMode,
    resetSearchMode: () => {
      setSearchMode(false);
    },
    searchValue,
    onSearchValueChange: handleSearchValueChange,
    onSearch: handleSearch,
  };
}
